import React, { ReactNode, useMemo } from 'react';

import { UiComponent } from 'components';
import { tableWrap, tableToolbar } from 'styles/table';
import { IAdditional, IPageOption } from 'types';
import { BsPlusLg } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import { EVENT_MENU_URL } from 'data/menu';
import { usePermission } from 'hooks';
import dayjs from 'dayjs';
import { BiPencil } from 'react-icons/bi';

// const COLS: string[] = ['ID', '타이틀', '생성자', '생성일'];
const COLS: string[] = ['ID', '타이틀', '생성일'];

interface Props {
  pageOption: IPageOption;
  handlePage: (option: IPageOption) => void;
  data: IAdditional[];
  totalPage: number;
  toolbar?: ReactNode;
}

function List({ data, toolbar, ...pageOptions }: Props) {
  const navigate = useNavigate();
  const can = usePermission();

  const handleView = (id: number) => {
    navigate(`${EVENT_MENU_URL['추가정보 템플릿']}/${id}`);
  };

  const renderer: Record<
    (typeof COLS)[number],
    (data: IAdditional & { row: number }) => ReactNode
  > = useMemo(
    () => ({
      ID: ({ id }: IAdditional) => <>{id}</>,
      타이틀: ({ id, title }: IAdditional) => (
        <p
          css={{
            textAlign: 'left',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
          title="추가정보 템플릿 수정"
          onClick={() => handleView(id)}
        >
          {title}
          <span css={{ marginLeft: '4px' }}>
            <BiPencil size={11} />
          </span>
        </p>
      ),
      // 생성자: ({ creator }: IAdditional) => <>{creator}</>,
      생성일: ({ createdAt }: IAdditional) => (
        <>{dayjs(createdAt).format('YYYY-MM-DD HH:mm')}</>
      ),
    }),
    [],
  );

  return (
    <>
      <UiComponent.Box>
        <div css={tableToolbar}>
          {toolbar ?? <div />}
          <div>
            {can('additional_template:create') && (
              <UiComponent.Button
                variant="contained"
                color="primary"
                onClick={() =>
                  navigate(`${EVENT_MENU_URL['추가정보 템플릿']}/register`)
                }
                css={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: '0 4px',
                }}
              >
                <BsPlusLg size={15} />
                <p css={{ fontSize: '14px' }}>추가정보 템플릿 추가</p>
              </UiComponent.Button>
            )}
          </div>
        </div>
        <div css={tableWrap}>
          <UiComponent.Table
            cols={COLS}
            renderer={renderer}
            data={data}
            sticky
          />
        </div>
        <UiComponent.Pagination {...pageOptions} />
      </UiComponent.Box>
    </>
  );
}

export default List;
